import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { TaskListDTO } from '@nx-frontend/shared/types';

interface CopyTaskListParams {
  serviceUrl: string;
  workspaceId: string;
  taskListId: string;
  userId?: number;
  secret?: string;
  targetNoteGlobalId: string;
  targetWorkspaceId: string;
}

export async function copyTaskList({
  workspaceId,
  taskListId,
  serviceUrl,
  userId,
  secret,
  targetNoteGlobalId,
  targetWorkspaceId,
}: CopyTaskListParams): Promise<TaskListDTO> {
  const headers: Record<string, string> = {};
  if (secret) {
    headers['X-Secret'] = secret;
  }
  const response = await axiosClient.post<TaskListDTO>(
    `${assertServiceHost(serviceUrl)}/v1/workspaces/${encodeURIComponent(workspaceId)}/taskLists/${encodeURIComponent(
      taskListId
    )}/copy`,
    {
      noteGlobalId: targetNoteGlobalId,
      workspaceId: targetWorkspaceId,
    },
    {
      headers,
      userId,
      secret,
    }
  );
  return response.data;
}
